var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28622",
    "data-name": "Group 28622",
    transform: "translate(-79 -388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8000",
    "data-name": "Rectangle 8000",
    transform: "translate(79 388)",
    fill: "#fff",
    stroke: "#EB1700",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 33,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 25,
    height: 31,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28621",
    "data-name": "Group 28621",
    transform: "translate(1 -0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16803",
    "data-name": "Path 16803",
    d: "M6142,1702.75h15.5",
    transform: "translate(-6058 -1305)",
    fill: "#EB1700",
    stroke: "#EB1700",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16804",
    "data-name": "Path 16804",
    d: "M6142,1702.75h15.5",
    transform: "translate(-6058 -1300)",
    fill: "#EB1700",
    stroke: "#EB1700",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16805",
    "data-name": "Path 16805",
    d: "M6142,1702.75h15.5",
    transform: "translate(-6058 -1295)",
    fill: "#EB1700",
    stroke: "#EB1700",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16806",
    "data-name": "Path 16806",
    d: "M6142,1702.75h15.5",
    transform: "translate(-6058 -1290)",
    fill: "#EB1700",
    stroke: "#EB1700",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIconBlack);
export default __webpack_public_path__ + "static/media/documentIcon-black.2c12704445138334ee67bd0d1a35e048.svg";
export { ForwardRef as ReactComponent };